/**
 * Created by andrey on 25.03.2026
 */

const LocationConfigResolver = {
    resolveChildMission: function (mission) {
        if (typeof mission === "string") {
            return Mission[mission];
        }
        const resolved = { ...mission };
        resolved.type = Mission[mission.type];
        if (mission.levels) {
            resolved.levels = PassLevelsConfig[mission.levels];
        }
        return resolved;
    },

    resolveOffer: function (offer) {
        if (typeof offer === "string") {
            return Offers.TYPES[offer];
        }
        const resolved = { ...offer };
        resolved.id = Offers.TYPES[offer.id];
        if (offer.base) {
            resolved.base = Offers.TYPES[offer.base];
        }
        if (offer.force) {
            resolved.force = Forces[offer.force];
        }
        if (offer.view === "OfferWindow") {
            resolved.view = OfferWindow;
        }
        if (typeof offer.reward === "string") {
            resolved.reward = RewardsConfig[offer.reward];
        }
        if (typeof offer.rewardByPayerLevel === "string") {
            resolved.rewardByPayerLevel = RewardsConfig[offer.rewardByPayerLevel];
        }
        if (offer.extraBarIcon) {
            if (bundles.extrabar) {
                resolved.extraBarIcon = {
                    json: bundles.extrabar.jsons[offer.extraBarIcon.json],
                    background: bundles.extrabar.frames[offer.extraBarIcon.background]
                };
            } else {
                delete resolved.extraBarIcon;
            }
        }
        if (typeof offer.cooldown === "object" && offer.cooldown.debug) {
            resolved.cooldown = cleverapps.config.debugMode ? offer.cooldown.debug : offer.cooldown.release;
        }
        if (typeof offer.inABExperiments === "object" && offer.inABExperiments.test) {
            const { test } = offer.inABExperiments;
            const { group } = offer.inABExperiments;
            if (offer.inABExperiments.negate) {
                resolved.inABExperiments = function () {
                    return cleverapps.abExperiments.getGroup(ABExperiments.Tests[test]) !== group;
                };
            } else {
                resolved.inABExperiments = function () {
                    return cleverapps.abExperiments.getGroup(ABExperiments.Tests[test]) === group;
                };
            }
        }
        return resolved;
    },

    SLOT_NAMES: ["SLOT_MAIN", "EXPEDITION_SLOT1", "EXPEDITION_SLOT2", "EXPEDITION_SLOT3", "EXPEDITION_SLOT4", "EXPEDITION_SLOT5"],

    resolveLocationsList: function (entries) {
        return this.filterLocations(Object.values(entries).map((entry) => {
            const available = entry.id !== "main"
                ? cleverapps.config.availables[`${entry.id.toUpperCase()}_LOCATION`] || entry.available
                : undefined;

            return this.resolve(entry.id, {
                slotId: Meta[LocationConfigResolver.SLOT_NAMES[entry.slotId]],
                retire: entry.retire,
                schedule: entry.schedule,
                available,
                finishQuest: entry.finishQuest,
                abTest: entry.abTest
            });
        }));
    },

    listRetiredLocationIds: function (entries) {
        if (cleverapps.config.name === "map2deditor" || !entries) {
            return [];
        }
        return Object.values(entries)
            .filter((entry) => entry.retire !== false && !bundles[`location_${entry.id}`])
            .map((entry) => entry.id);
    },

    resolve: function (locationId, overrides) {
        const bundle = typeof bundles !== "undefined" && bundles[`location_${locationId}`];
        const config = bundle && bundle.meta && bundle.meta.locationConfig;
        if (!config) {
            return undefined;
        }
        const result = { ...config, ...overrides };
        if (config.sideBarIcon && bundles.sidebar && bundles.sidebar.jsons) {
            result.sideBarIcon = bundles.sidebar.jsons[config.sideBarIcon];
        }
        if (result.childMissions) {
            result.childMissions = result.childMissions.map(LocationConfigResolver.resolveChildMission);
        }
        if (result.offers) {
            result.offers = result.offers.map(LocationConfigResolver.resolveOffer);
        }

        result.locationType = result.locationType || "merge";
        result.version = result.version || 0;

        return result;
    },

    filterLocations: function (locations) {
        const result = {};

        locations.forEach((location) => {
            if (!location) {
                return;
            }

            if (cleverapps.config.name !== "map2deditor") {
                let available = location.available || {};

                if (available.feature && (cleverapps.config.features || []).indexOf(available.feature) === -1) {
                    location.unknown = true;
                }

                available = available[cleverapps.config.name] || available;

                if (available.projectName && cleverapps.toArray(available.projectName).indexOf(cleverapps.config.name) === -1) {
                    return;
                }

                if (available.debugMode && !cleverapps.config.debugMode) {
                    return;
                }

                if (location.legacyMissionType !== undefined) {
                    Mission.MISSION_TYPE_BY_LOCATION_ID[location.id] = location.legacyMissionType;
                }
            }

            result[location.id] = location;
        });

        return result;
    },

    registerOffers: function (locations) {
        Object.values(locations).forEach((locationData) => {
            locationData.offers = (locationData.offers || []).map((offerData) => {
                if (typeof offerData !== "object") {
                    return offerData;
                }

                const id = offerData.id;
                const baseOfferId = offerData.base;

                offerData.type = id;
                delete offerData.id;
                delete offerData.base;

                Offers[id] = { ...Offers[baseOfferId], ...offerData };

                return id;
            });
        });
    },

    registerMissions: function (locations) {
        Object.values(locations).forEach((location) => {
            if (!location.childMissions) {
                return;
            }

            location.childMissions.forEach((missionData) => {
                const type = missionData.type !== undefined ? missionData.type : missionData;

                const compoundType = Mission.CompoundType(type, location.id);
                const childParams = {
                    location: location.id,
                    type: compoundType
                };

                if (missionData.startFog) {
                    childParams.manualStart = ManualStarters.FogStarter;
                    childParams.startFog = missionData.startFog;
                }
                if (missionData.startUnit) {
                    childParams.manualStart = ManualStarters.UnitStarter;
                    childParams.startUnit = missionData.startUnit;
                }
                if (missionData.guideWindow !== undefined) {
                    childParams.guideWindow = missionData.guideWindow;
                }
                if (missionData.levels) {
                    childParams.levels = missionData.levels;
                }

                Mission.REGISTRATIONS.set(compoundType, () => ({
                    ...Mission.REGISTRATIONS.get(type)(), ...childParams
                }));
            });
        });
    }
};
